import useSWR from 'swr';
import apiClient from '../helpers/ApiClient';

const fetcher = (url) => apiClient.get(url).then(res => res.data);

export function useActiveShift() {
  const { data, error, mutate } = useSWR('/shifts/active', fetcher);
  return {
    shift: data?.shift,
    isLoading: !error && !data,
    isError: error,
    mutate
  };
}

export async function openShift(openingCash, openingDenominations) {
  const res = await apiClient.post('/shifts/open', { openingCash, openingDenominations });
  return res.data;
}

export async function closeShift(shiftId, closingCash, closingDenominations, expectedCash, cashDifference) {
  const res = await apiClient.post('/shifts/close', { shiftId, closingCash, closingDenominations, expectedCash, cashDifference });
  return res.data;
}

export function useCurrentRegister() {
  const { data, error, mutate } = useSWR('/registers/current', fetcher);
  return {
    data,
    isLoading: !error && !data,
    isError: error,
    mutate
  };
}

export function useDayBook(from, to) {
  const { data, error, mutate } = useSWR(`/daybook?from=${from}&to=${to}`, fetcher);
  return {
    data,
    isLoading: !error && !data,
    isError: error,
    mutate
  };
}
